const BATCH_CDF_EVENTS_FLAG = 'cash-web-batch-cdf-events'

/**
 * Reads the `cash-web-batch-cdf-events` LaunchDarkly flag from the flags the server injects on the page.
 * This lib cannot use the React flag hooks, and events can be logged outside the component tree.
 */
export function isBatchingEnabled(): boolean {
  const flags = (globalThis.window as { featureFlagsJson?: Record<string, unknown> } | undefined)?.featureFlagsJson
  return flags?.[BATCH_CDF_EVENTS_FLAG] === true
}
